import { InboxIcon, PlusIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { useKeycloak } from '@react-keycloak/web';
import React from 'react';

import CLocalizedTextStringStatic from '../../components/CLocalizedTextStringStatic';
import CPageModule from '../../components/CPageModule';
import ActionLinkButton from '../../components/dashboardContent/ActionLinkButton';
import Page from '../../components/layout/Page';
import PageModuleTitle from '../../components/layout/PageModuleTitle';
import XDResponsiveGridWrapper from '../../components/layout/XDResponsiveGridWrapper';
import { EUserRoles } from '../../enums/EUserRoles';
import { PageRoutes } from '../../enums/enums';
import { userHasRole } from '../../utils/utils';

export default function UserManagementIndex() {
  const { keycloak } = useKeycloak();
  const isAdmin = userHasRole(keycloak.tokenParsed, [[EUserRoles.ADMIN]]);
  const userAccountsText = CLocalizedTextStringStatic('sidebar.userAccounts');
  const createAccountText = CLocalizedTextStringStatic('userManagement.index.createAccount');
  const manageAccountsText = CLocalizedTextStringStatic('userManagement.index.manageAccounts');
  const accountRequestsText = CLocalizedTextStringStatic('signUp.account.all.requests');
  return (
    <Page>
      <CPageModule>
        <PageModuleTitle>{userAccountsText}</PageModuleTitle>
        <XDResponsiveGridWrapper>
          {isAdmin && (
            <ActionLinkButton label={createAccountText} to={PageRoutes.USERS_NEW}>
              <PlusIcon />
            </ActionLinkButton>
          )}
          <ActionLinkButton label={manageAccountsText} to={PageRoutes.USERS_OVERVIEW_OUTLET}>
            <UserGroupIcon />
          </ActionLinkButton>
          <ActionLinkButton label={accountRequestsText} to={PageRoutes.SIGN_UP_REQUESTS_OUTLET}>
            <InboxIcon />
          </ActionLinkButton>
        </XDResponsiveGridWrapper>
      </CPageModule>
    </Page>
  );
}
